import { HelperFunctions } from './../../shared/Helpers/helperFunctions';
import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { SharedService } from '../../shared/shared.service';
import { Constants } from '../../shared/Helpers/constants';
import { Router } from '@angular/router';
import { UserService } from 'src/app/_services';
import { GlobalValidator } from 'src/app/shared';
import { IUser, IUserForgotPassDetails } from 'src/app/shared/interfaces/IUser';
import { IAnswersOfSelectedQuestions, IDropdown, ISecurityQuestion, ISecurityQuestionsAnswers } from 'src/app/shared/interfaces';
import { Alert, AlertTypeEnum } from 'src/app/shared/Helpers/Alert';
import { stringify } from 'querystring';

@Component({
  selector: 'forgot-password',
  templateUrl: './forgot-pwd.component.html'
})
export class ForgotPwdComponent {
  public hideForm: boolean = false;
  public forgotPwdForm: FormGroup;
  public usernameSecQuestionForm: FormGroup;
  public securityQuestionForm: FormGroup;
  public securityQuestionNestedForm: FormGroup;
  public logoPath: any;
  public secQuestionsSelected: boolean = true;
  public recoveryEmailSelected: boolean = false;
  public usernameSubmitted: string = '';
  public securityQuestionsForUsername: Array<ISecurityQuestion> = [];
  public questionsLoaded: boolean = false;
  public secQuesToDisplay: any;
  public possibleSecurityQuestions: any;
  public usernameReturned: any;
  public passwordMode: boolean = true;
  public passwordInput: string = 'password';
  public confirmPasswordInput: string = 'password';
  public passwordStrengthValidation: boolean = true;
  public dropdownCurrentQuestion: any = 'Select question';
  public securityQuestionsList: Array<IDropdown> = [];
  public userdetails: IUserForgotPassDetails | any;
  public passwordCharNumber: number = 0;
  public upperCaseNo: number = 0;
  public lowerCaseNo: number = 0;
  public containsNo: number = 0;
  public specialCharNo: number = 0;
  public usernameChar: boolean = true;
  public passwordValidation: boolean = false;
  public user: IUser;
  public usernameContains: boolean = true;
  public customRulesValidation: boolean;
  public passwordContainsSpace: boolean = false;
  public passwordContainsNames: boolean = false;
  public isAnswerLengthValid: boolean = false;

  constructor(
    private _formBuilder: FormBuilder,
    private _userService: UserService,
    private _router: Router,
    public sharedService: SharedService
  ) {
    this.initRecoveryEmailForm();
    this.initUsernameSecQuesForm();
    this.initSecurityQuestionForm();
  }

  ngDoCheck() {
    if (this.sharedService.loadedOrganisationByUrl.value) {
      if (this.sharedService.loginCustomisation.value != undefined && this.sharedService.loginCustomisation.value != null) {
        if (this.sharedService.LogoImage.value != null) {
          this.logoPath = null;
          this.logoPath = this.sharedService.LogoImage.value;
        } else {
          this.logoPath = Constants.logoPath;
        }
      } else {
        this.logoPath = Constants.logoPath;
      }
    } else {
      this.logoPath = Constants.logoPath;
    }
  }

  private initRecoveryEmailForm(): void {
    this.forgotPwdForm = this._formBuilder.group({
      email: ['', [GlobalValidator.emailFormat, Validators.required]],
    });
  }

  private initUsernameSecQuesForm(): void {
    this.usernameSecQuestionForm = this._formBuilder.group({
      username: ['', [Validators.required]]
    })
  }

  private initSecurityQuestionForm() {
    this.securityQuestionForm = this._formBuilder.group({
      securityQuestion: this._formBuilder.array([
        this._formBuilder.group({
          securityQuestionId: [''],
          answer: '',
          selected: '',
          warning: ''
        })
      ]),
      username: [this.usernameSubmitted],
      passwordGroup: this._formBuilder.group({
        newPassword: ['', [Validators.required, Validators.minLength(6)]],
        confirmNewPassword: ['', [Validators.required, Validators.minLength(6)]]
      }, { validator: HelperFunctions.passwordMatcher }),
      passwordStrengthValidation: ['', [Validators.required]],
      checkNewPassword: ['']
    });
    (<FormArray>this.securityQuestionForm.controls.securityQuestion).removeAt(0);
  }

  public forgotPwdSubmit(): void {
    const email = this.forgotPwdForm.value;
    this._userService.forgotPassword(email).subscribe({
      next: () => {
        this.hideForm = true;
      },
      error: (err) => {
        if(err.error.errorCode == 1000) {
          Alert.basicNotification(AlertTypeEnum.Warning, "Warning", `Email address ${email.email} is not found as a validated recovery email address for any account.`);
        } else {
          Alert.basicNotification(AlertTypeEnum.Warning, "Warning", `Email address ${email.email} is not found as a validated recovery email address for any account.`);
        }
      }
    })
  }

  public onSelectSecQuestions() {
    this.secQuestionsSelected = true;
    this.recoveryEmailSelected = false;
  }

  public onSelectRecEmail() {
    this.recoveryEmailSelected = true;
    this.secQuestionsSelected = false;
  }

  public loadSecurityQuestionsFromIDAM() {
    this.usernameSubmitted = this.usernameSecQuestionForm.controls.username.value;
    this.userdetails = null;
    if(!this.sharedService.currentOrganisationId?.value) {
      this._router.navigateByUrl('/login');
    } else {
      this._userService.getSecurityPolicyByOrganisation(this.sharedService.currentOrganisationId?.value, this.usernameSubmitted).subscribe({
        next: (res) => {
          if (res) {
            this.userdetails = res.body;
          }
        }}
      )
    }

    this._userService.getSecurityQuestionsByUsername(this.usernameSubmitted).subscribe({
      next: (res) => {
        this.securityQuestionsForUsername = res.body;

        this.securityQuestionsForUsername.forEach(ques => {
          let dropdownObject: IDropdown = { label: ques.question, value: ques.id };
          this.securityQuestionsList.push(dropdownObject);
        });

        if (this.securityQuestionsForUsername.length == 0) {
          Alert.basicNotification(AlertTypeEnum.Warning, "Warning", "You do not have security questions stored in Able+. Try again by using your recovery email.");
        } else {
          this.questionsLoaded = true;
          this.patchSecurityQuestionForm();
        }
      },
      error: () => {
        const errorMessage: string = `Username not recognised. Please try again or contact your organisation's Able+ administrator.`;
        Alert.basicNotification(AlertTypeEnum.Warning, "Warning", errorMessage);
      }
    })
  }

  private patchSecurityQuestionForm() {
    this.secQuesToDisplay = <FormArray>this.securityQuestionForm.controls['securityQuestion'];

    if (this.securityQuestionsForUsername.length > 0) {
      let min = 3;
      if (min > this.securityQuestionsList.length) {
        min = this.securityQuestionsList.length;
      }
      for (let i = 0; i < min; i++) {
        const newSecurityQuesiton = this._formBuilder.group({
          securityQuestionId: [''],
          answer: ['', [Validators.required, Validators.minLength(min), Validators.pattern('^[a-zA-Z0-9 ]+$')]],
          selected: [''],
          warning: ['1']
        })
        this.secQuesToDisplay.push(newSecurityQuesiton);
      }
    }
  }

  public onSelectSecurityQuestion(secQuestionId: string, index: number) {
    const selectedSecurityQuestion: Array<any> = [];
    let firstItemSelected;
    this.secQuesToDisplay.controls[index].patchValue({
      securityQuestionId: secQuestionId,
      selected: true
    })

    const objectQuestion = {
      securityQuestionId: this.secQuesToDisplay.controls[index].value.securityQuestionId,
      isSelectedQuestion: this.secQuesToDisplay.controls[index].value.selected
    };
    selectedSecurityQuestion.push(objectQuestion);

    if (this.secQuesToDisplay.controls.filter(item => item.value.selected == true).length > 1) {
      firstItemSelected = this.secQuesToDisplay.controls[index].value;
      let sameQuestions = this.secQuesToDisplay.controls.filter(item => item.value.securityQuestionId == firstItemSelected.securityQuestionId);

      if (sameQuestions.length > 1) {
        for (let i = 0; i < sameQuestions.length; i++) {
          sameQuestions[i].value.warning = '2';
        }
      } else {
        for (let i = 0; i < this.secQuesToDisplay.controls.length; i++) {
          this.secQuesToDisplay.controls[i].value.warning = '1';
        }
      }
    }
  }

  public checkIfDuplicatedQuestionSelected() {
    const firstQuestion = this.secQuesToDisplay.controls[0].value.securityQuestionId;

    let sameQuestions = this.secQuesToDisplay.controls.filter(item => item.value.securityQuestionId == firstQuestion)

    if (sameQuestions.length > 1 || !this.securityQuestionForm.get('passwordGroup').valid || !this.securityQuestionForm.get('securityQuestion').valid)
      return true;
    else
      return false;
  }

  public checkIfDuplicatedQuestionSelectedByIndex(index) {
    const firstQuestion = this.secQuesToDisplay.controls[index].value.securityQuestionId;

    if (firstQuestion) {
      let sameQuestions = this.secQuesToDisplay.controls.filter(item => item.value.securityQuestionId == firstQuestion)

      if (sameQuestions.length > 1) {
        for (let i = 0; i < this.secQuesToDisplay.controls.length; i++) {
          this.secQuesToDisplay.controls[i].get('answer').disable();
        }
        return true;
      }
      else {
        for (let i = 0; i < this.secQuesToDisplay.controls.length; i++) {
          this.secQuesToDisplay.controls[i].get('answer').enable();
        }
        return false;
      }
    }
  }

  public verifyAnswersForSecurityQuestions() {
    const questions = this.securityQuestionForm.value;
    if (questions.securityQuestion.length > 0) {
      let dtoObject: ISecurityQuestionsAnswers = {
        newPassword: questions.passwordGroup.newPassword,
        username: this.usernameSubmitted,
        securityAnswers: this.createAnswersArrayObject(questions.securityQuestion)
      }

      this._userService.verifySecurityQuestionsViaUsername(dtoObject).subscribe({
        next: () => {
          Alert.basicNotification(AlertTypeEnum.Success, "", "New password updated successfully");
          this._router.navigate(['login']);
        },
        error: (error) => {
          if (error.error.errorCode == 1006 && error.error.detailedMessage == 'You have tried to use an existing expired password. Please choose a new password.') {
            Alert.basicNotification(AlertTypeEnum.Warning, "", error.error.detailedMessage);
          } else if (error.error.errode == 1002) {
            Alert.basicNotification(AlertTypeEnum.Warning, "", "Cannot change password for a person who is not ACTIVE.");
          } else if (error.error.errode == 1006 && error.error.detailedMessage == 'Invalid Security Questions') {
            Alert.basicNotification(AlertTypeEnum.Warning, "", "One or more of your answers were incorrect and therefore it is not possible to authenticate your details for login. Try again or use your recovery email address instead. Alternatively contact your Able+ administrator to reset the password for you.");
          } else {
            Alert.basicNotification(AlertTypeEnum.Warning, "", "One or more of your answers were incorrect and therefore it is not possible to authenticate your details for login. Try again or use your recovery email address instead. Alternatively contact your Able+ administrator to reset the password for you.");
          }
        }
      })
    }
  }

  private createAnswersArrayObject(object) {
    let answerOfQuestion: IAnswersOfSelectedQuestions;
    let retObject: IAnswersOfSelectedQuestions[] = [];

    object.forEach(item => {
      answerOfQuestion = {
        answer: item.answer,
        securityQuestion: {
          id: item.securityQuestionId
        }
      };
      retObject.push(answerOfQuestion);
    })
    return retObject;
  }

  public passwordModeOn(check: boolean, inputField: boolean) {
    if (!check) {
      if (inputField) {
        this.passwordInput = 'password';
      } else {
        this.confirmPasswordInput = 'password';
      }
      this.passwordMode = true;
    } else {
      if (inputField) {
        this.passwordInput = 'text';
      } else {
        this.confirmPasswordInput = 'text';
      } this.passwordMode = false;
    }
  }

  public checkAnswersLength = (value: string, minLength: number) => {
    this.isAnswerLengthValid = false;
    if(value.length < minLength) {
      this.isAnswerLengthValid = false;
    } else {
      this.isAnswerLengthValid = true;
    }
  }

  // check password strength
  public checkPasswordStrength(input: string) {
    const caseInsensitiveInput = input.toLowerCase();
    if (this.userdetails != undefined) {
      this.passwordValidation = true;

      if (this.userdetails.security.passwordUpperCaseRestriction) {
        this.upperCaseNo = 0;
        for (var i = 0; i < input.length; i++) {
          if (input[i] === input[i].toUpperCase() && input[i] !== input[i].toLowerCase()) {
            this.upperCaseNo++
          }
        }
        if (this.upperCaseNo < this.userdetails.security.passwordUpperCaseNo) {
          this.passwordValidation = false;
        }
      }
      if (this.userdetails.security.usernameRestriction) {
        this.usernameChar = true;
        if (input.length > this.userdetails.security.usernameCharacterNo || input.length == this.userdetails.security.usernameCharacterNo) {
          if (this.userdetails.firstname != "") {
            const firstname = this.userdetails.firstname.split('').reduce((s, c) => { let l = s.length - 1; (s[l] && s[l].length < this.userdetails.security.usernameCharacterNo) ? s[l] += c : s.push(c); return s; }, []);
            firstname.forEach((x: any) => {
              if (x.length == this.userdetails.security.usernameCharacterNo) {
                if (caseInsensitiveInput.includes(x)) {
                  this.usernameChar = false;
                  this.passwordValidation = false;
                }
              }
            })
          }
          if (this.userdetails.middlename != "") {
            const middleName = this.userdetails.middlename?.split('').reduce((s, c) => { let l = s.length - 1; (s[l] && s[l].length < this.userdetails.security?.usernameCharacterNo) ? s[l] += c : s.push(c); return s; }, []);
            middleName?.forEach((x: any) => {
              if (x.length == this.userdetails.security.usernameCharacterNo) {
                if (caseInsensitiveInput.includes(x)) {
                  this.usernameChar = false;
                  this.passwordValidation = false;
                }
              }
            })
          }
          if (this.userdetails.lastname != "") {
            const surname = this.userdetails.lastname?.split('').reduce((s, c) => { let l = s.length - 1; (s[l] && s[l].length < this.userdetails.security?.usernameCharacterNo) ? s[l] += c : s.push(c); return s; }, []);
            surname?.forEach((x: any) => {
              if (x.length == this.userdetails.security.usernameCharacterNo) {
                if (caseInsensitiveInput.includes(x)) {
                  this.usernameChar = false;
                  this.passwordValidation = false;
                }
              }
            })
          }
        }
        if (caseInsensitiveInput.includes(this.userdetails.username?.toLowerCase()) || caseInsensitiveInput == this.userdetails.username?.toLowerCase()) {
          this.usernameContains = false;
          this.passwordValidation = false;
        } else {
          this.usernameContains = true;
        }
      }
      if (this.userdetails.security.passwordLowerCaseRestriction) {
        this.lowerCaseNo = 0;
        for (var i = 0; i < input.length; i++) {
          if (input[i] !== input[i].toUpperCase() && input[i] === input[i].toLowerCase()) {
            this.lowerCaseNo++
          }
        }
        if (this.lowerCaseNo < this.userdetails.security?.passwordLowerCaseNo) {
          this.passwordValidation = false;
        }
      }
      if (this.userdetails.security.passwordNumberRestriction) {
        this.containsNo = 0;
        for (var i = 0; i < input.length; i++) {
          if (/[0-9]/.test(input[i])) {
            this.containsNo++;
          }
        }
        if (this.containsNo < this.userdetails.security?.passwordNumberNo) {
          this.passwordValidation = false;
        }
      }
      if (this.userdetails.security.passwordSpecialCharRestriction) {
        var specialChars = "<>@!#$%^&*()_+[]{}?:;|'\"\\,./~`-="
        this.specialCharNo = 0;
        for (var i = 0; i < input.length; i++) {
          if (specialChars.indexOf(input[i]) != -1) {
            this.specialCharNo++
          }
        }
        if (this.specialCharNo < this.userdetails.security?.passwordSpecialCharNo) {
          this.passwordValidation = false;
        }
      }
      this.passwordCharNumber = input.length;
      if (this.passwordCharNumber < this.userdetails.security?.passwordMinCharacterNo) {
        this.passwordValidation = false;
      }

      if (this.userdetails.security?.customRules) {
        var regexNotFound = 0;
        for (var i = 0; i < this.userdetails.security?.customRules.length; i++) {
          if (!this.securityQuestionForm.get('passwordGroup.newPassword').value.match(this.userdetails.security?.customRules[i].regularExpression))
            regexNotFound++
        }
        if (regexNotFound > 0) {
          this.customRulesValidation =  false;
          this.passwordValidation = false;
        }
        else {
          this.customRulesValidation = true;
        }
      }
      if (this.userdetails.security.passwordSpaceRestriction) {
        this.passwordContainsSpace = false;
        if (input.indexOf(' ') > 0) {
          this.passwordContainsSpace = true;
          this.passwordValidation = false;
        }
      }
      if (this.userdetails.security.passwordUsersNameRestriction) {
        this.passwordContainsNames = false;
        if (this.userdetails.security?.minUsersNameCharacters == 0) {
          if (caseInsensitiveInput.includes(this.userdetails.middlename) || caseInsensitiveInput.includes(this.userdetails.firstname) || caseInsensitiveInput.includes(this.userdetails.lastname) || caseInsensitiveInput.includes(this.userdetails.displayname)) {
            this.passwordValidation = false;
            this.passwordContainsNames = true;
          }
        }
        if (this.userdetails.security?.minUsersNameCharacters > 0) {
          //check if length of firstName or surname or displayname or middleName is >= to this property value; if so => check if those words are used for password
          let fieldsToCheck: string[] = [this.userdetails.firstname, this.userdetails.displayname, this.userdetails.lastname, this.userdetails.middlename];

          if (input.length >= this.userdetails.security?.minUsersNameCharacters) {
            var containsUsername = HelperFunctions.containsSubstringInList(caseInsensitiveInput, this.userdetails.security?.minUsersNameCharacters + 1, fieldsToCheck)
            this.passwordValidation = containsUsername == true ? false : this.passwordValidation;
            this.passwordContainsNames = containsUsername;
          }
        }
      }
    }
  }
}
